import React from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { CommonStyles, Color, CommonProperties } from '../../styles';
import Slide from './Slide';
import PNRInfo from './PNRInfo';
import PassengerInfo from './PassengerInfo';
import TabBar from '../SegmentedControl/TabBar';
import Images from '../../constants/Images';
import BaseText from '../BaseText';
import { useNavigation } from '@react-navigation/native';
import { Screens, Modals } from '../../constants/ScreenNames';
import Bar from '../SegmentedControl/Bar';
import useAvailableHeight from '../../utils/useAvailableHeight';
import { scale } from '../../utils/scale.utils';
import { useTranslation } from 'react-i18next';
import { i18nNS, useComponentTKey } from '../../i18n';

const CARS = 'CARS';
const DIRECTIONS = 'DIRECTIONS';
const RIDESHARE = 'RIDESHARE';

const CarPage = ({ travel, passengers }) => {
  const { t } = useTranslation(i18nNS.tripHub);
  const { tKey } = useComponentTKey('CarPage');
  const navigation = useNavigation();
  const availableHeight = useAvailableHeight(scale(150));

  const carTabItems = [
    //{ icon: 'car', second: 'Cars', value: CARS },
    { icon: 'gps', label: t(tKey('DIRECTIONS')), value: DIRECTIONS },
    { icon: 'car', label: t(tKey('RIDESHARE')), value: RIDESHARE },
  ];

  const onChange = (value) => {
    switch (value) {
      case CARS:
        navigation.navigate(Screens.CarChange);
        break;
      case DIRECTIONS:
        navigation.navigate(Modals.DirectionModal, { page: 'car' });
        break;
      case RIDESHARE:
        navigation.navigate(Modals.RideShareModal, { page: 'car' });
        break;
    }
  };

  return (
    <ScrollView>
      <View style={{ height: availableHeight, backgroundColor: 'white' }}>
        <Slide
          image={
            Images.car['50x20'][travel.VendorCode]
              ? Images.car['50x20'][travel.VendorCode]
              : Images.car['50x20']['other']
          }
          name={travel.VendorName + ' Rental Car'}
          detail={travel.PickupAddress || travel.PickupCityState}
          startLabel={t(tKey('PickUp'))}
          startTime={travel.PickupTime || '--'}
          startDetail={travel.PickupDate}
          endLabel={t(tKey('DropOff'))}
          endTime={travel.DropoffTime || '--'}
          endDetail={travel.DropoffDate}
        >
          <BaseText>{t(tKey('OnAirport'))}</BaseText>
        </Slide>
        <Bar items={carTabItems} onChange={onChange} style={styles.tabBar} />
        <PNRInfo
          style={CommonStyles.mb3}
          label={t(tKey('CarReservation'))}
          value={travel.ConfirmationNumber}
        />
        {passengers?.length > 0
          ? passengers.map((passenger, index) => (
              <PassengerInfo
                key={index}
                label={t(tKey('Driver'))}
                value={passenger.FirstName + ' ' + passenger.LastName}
              />
            ))
          : null}
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  tabBar: {
    borderTopWidth: 0.1,
    borderTopColor: Color.gray,
    ...CommonProperties.py5,
  },
});

export default CarPage;
